
import PokerTablePokerBase from "../../../table/module/poker_table/poker_table_poker_base";
import PokerTableSeatPokers from "../../../table/module/poker_table/poker_seat_pokers_base";

const { ccclass, property, menu } = cc._decorator;

export enum SelectState{
    Normal = 0,
    Disable = 1,
    Selected = 2,
}

@ccclass
export default class Q2MyHandCardsPattern extends PokerTableSeatPokers{

    @property(cc.Layout)
    layout: cc.Layout = null

    @property(cc.Node)
    nodeRaiseTag: cc.Node = null

    @property(cc.Node)
    nodeStorageTag: cc.Node = null

    @property(cc.Node)
    nodeAttachTag: cc.Node = null

    @property(cc.Node)
    nodeDiscardTag: cc.Node = null

    @property(cc.Node)
    nodeTagBg: cc.Node = null

    protected formatPokersLayout(pokerList: PokerTablePokerBase[]): cc.Vec2{
        for (let i = 0; i < pokerList.length; i++) {
            let poker = pokerList[i];                      
            poker.node.position = cc.Vec2.ZERO
            poker.original_pos = cc.Vec2.ZERO
            poker.node.zIndex = i 
        }
        this.udpateLayout()
        return cc.Vec2.ZERO
    }

    protected udpateLayout(){
        this.layout.updateLayout()
        this.nodeTagBg.width = this.layout.node.width
        this.node.width = this.layout.node.width
    }
        

    showRaiseTag(show: boolean){
        this.nodeRaiseTag.active = !!show
    }

    showStorageTag(show: boolean){
        this.nodeStorageTag.active = !!show
    }

    showAttachTag(show: boolean){
        this.nodeAttachTag.active = !!show
    }

    showDiscardTag(show: boolean){
        this.nodeDiscardTag.active = !!show
    }
}
